(function (window, document) {
  'use strict';
  var core = window.EarlyBFCore;
  if (!core || !window.EarlyBF) { if (window.EarlyBF) window.EarlyBF.deactivate(); return; }
  var config = window.EarlyBFConfig;
  var nativeBadgeHomes = new WeakMap();
  var ownerSelector = '[data-product-options], [data-bf-card], [data-product-featured]';
  function arrangeNativeBadges(root, promotional) {
    if (!root || !root.querySelectorAll) return;
    var stack = root.querySelector('.bf-image-badges');
    if (stack && stack.closest(ownerSelector) !== root) stack = null;
    root.querySelectorAll('[data-product-badge],[data-product-single-badge]').forEach(function (native) {
      if (native.closest(ownerSelector) !== root) return;
      var home = nativeBadgeHomes.get(native);
      if (promotional && stack) {
        if (!home) nativeBadgeHomes.set(native, { parent: native.parentNode, next: native.nextSibling });
        if (native.parentNode !== stack) stack.appendChild(native);
      } else if (home) {
        if (home.parent.isConnected) home.parent.insertBefore(native, home.next && home.next.parentNode === home.parent ? home.next : null);
        nativeBadgeHomes.delete(native);
      }
    });
  }
  function escape(value) {
    return String(value).replace(/[&<>"']/g, function (char) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]; });
  }
  function format(value) {
    core.money(value);
    if (window.T4SThemeSP && window.T4SThemeSP.Currency) return window.T4SThemeSP.Currency.formatMoney(value);
    // Match Shopify's money placeholders without parsing formatted DOM text.
    var formats = { amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_apostrophe_separator: [2, "'", '.'] };
    var template = config.moneyFormat || '{{amount}} ' + config.currency;
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, name) {
      var spec = formats[name];
      if (!spec) return escape(new Intl.NumberFormat(config.locale || 'ro-RO', { style: 'currency', currency: config.currency }).format(value / 100));
      var rounded = spec[0] ? value : Math.round(value / 100);
      var whole = String(spec[0] ? Math.floor(rounded / 100) : rounded).replace(/\B(?=(\d{3})+(?!\d))/g, spec[1]);
      return whole + (spec[0] ? spec[2] + String(rounded % 100).padStart(2, '0') : '');
    });
  }
  function presentation(meta, discount) {
    var low = core.presentation(meta.price, discount.amount, meta.compareAt);
    var high = low;
    var percentMin = low.percent, percentMax = low.percent;
    if (meta.range) {
      var variants = meta.variants && meta.variants.length ? meta.variants : [{ price: meta.priceMin }, { price: meta.priceMax }];
      var interval = core.presentationRange(variants, discount.amount);
      low = { original: interval.originalMin, final: interval.finalMin };
      high = { original: interval.originalMax, final: interval.finalMax };
      percentMin = interval.percentMin; percentMax = interval.percentMax;
    }
    var percent = percentMin === percentMax ? '−' + percentMin + '%' : '−' + percentMin + '–' + percentMax + '%';
    return { low: low, high: high, percent: percent };
  }
  function markup(meta, discount, showLabel, showPercent) {
    var view = presentation(meta, discount), low = view.low, high = view.high;
    var original = format(low.original) + (low.original !== high.original ? ' – ' + format(high.original) : '');
    var finalPrice = format(low.final) + (low.final !== high.final ? ' – ' + format(high.final) : '');
    var html = '<span class="bf-price-values' + (meta.range ? ' bf-price-values--range' : '') + '">' +
      '<del><span class="visually-hidden">' + escape(config.labels.original) + ' </span>' + original + '</del>' +
      '<ins><span class="visually-hidden">' + escape(config.badgeLabel) + ' </span>' + finalPrice + '</ins></span>' +
      (showPercent === false ? '' : '<span class="bf-percent">' + view.percent + '</span>') + (showLabel === false ? '' : '<span class="bf-label">' + escape(config.badgeLabel) + '</span>');
    if (!meta.range && meta.unitPrice && meta.unitMeasurement && meta.price) {
      var measure = meta.unitMeasurement;
      html += '<span class="bf-unit-price">' + format(Math.round(meta.unitPrice * low.final / meta.price)) + ' / ' +
        escape((measure.reference_value !== 1 ? measure.reference_value : '') + measure.reference_unit) + '</span>';
    }
    return html;
  }
  function restoreNativeCompare(standard, meta, unavailable) {
    // An injected product-price renderer can replace Kalles' del/ins pair
    // with a sale-only span. Preserve its converted sale text and add only
    // the missing reference from the selected variant's numeric metadata.
    var price = standard.querySelector('[data-product-price][data-saletype]');
    if (!price || !price.querySelector) return;
    var restored = price.querySelector('[data-bf-native-compare-at]');
    if (unavailable || meta.range || meta.grouped || meta.unitMeasurement ||
        config.presentmentCurrency !== config.currency ||
        !Number.isSafeInteger(meta.price) || meta.price < 0 ||
        !Number.isSafeInteger(meta.compareAt) || meta.compareAt <= meta.price) {
      if (restored) restored.remove();
      return;
    }
    if (restored) {
      if (restored.dataset.bfCompareValue !== String(meta.compareAt)) {
        restored.innerHTML = format(meta.compareAt);
        restored.dataset.bfCompareValue = String(meta.compareAt);
      }
      return;
    }
    if (price.querySelector('del,s,.price-item--regular') || !price.querySelector('.price-item--sale.price-item--last')) return;
    var reference = document.createElement('del');
    reference.setAttribute('data-bf-native-compare-at', '');
    reference.dataset.bfCompareValue = String(meta.compareAt);
    reference.innerHTML = format(meta.compareAt);
    price.insertBefore(reference, price.firstChild);
    price.insertBefore(document.createTextNode(' '), reference.nextSibling);
  }
  function hydrate(element) {
    if (!element.isConnected) return;
    var standard = element.querySelector('[data-bf-standard]');
    var vip = element.querySelector('[data-bf-vip]');
    if (!standard || !vip) return;
    var active = window.EarlyBF.getState().active && config.presentmentCurrency === config.currency;
    var productRoot = element.closest && element.closest('[data-product-options], [data-bf-card], [data-product-featured]');
    var imageBadge = productRoot && productRoot.querySelector('[data-bf-image-badge]');
    if (imageBadge && imageBadge.closest('[data-product-options], [data-bf-card], [data-product-featured]') !== productRoot) imageBadge = null;
    var saleBadge = productRoot && productRoot.querySelector('[data-bf-sale-badge]');
    if (saleBadge && saleBadge.closest('[data-product-options], [data-bf-card], [data-product-featured]') !== productRoot) saleBadge = null;
    try {
      var meta = element.bfMeta || JSON.parse(element.getAttribute('data-bf-meta'));
      element.bfMeta = meta;
      var discount = active && !meta.grouped && !meta.giftCard && !meta.sellingPlan ? core.group(meta.tags, config) : null;
      if (discount) {
        var nativePrice = standard.querySelector('[data-product-price], [data-product-unit-price], .t4s-product-price, .t4s-widget__pr-price');
        vip.className = 'bf-price-vip ' + (nativePrice ? nativePrice.className : 't4s-product-price');
        if (nativePrice) vip.style.cssText = nativePrice.style.cssText;
        var html = markup(meta, discount, !imageBadge, !saleBadge);
        if (vip.innerHTML !== html) vip.innerHTML = html;
        if (saleBadge) {
          var percentBadge = saleBadge.querySelector('[data-bf-percent-badge]');
          var percentText = presentation(meta, discount).percent;
          if (percentBadge.textContent !== percentText) percentBadge.textContent = percentText;
        }
      }
      if (!discount) restoreNativeCompare(standard, meta, element.dataset.bfUnavailable);
      standard.hidden = Boolean(discount);
      vip.hidden = !discount;
      element.setAttribute('data-bf-ready', discount ? 'vip' : 'standard');
      if (productRoot) productRoot.setAttribute('data-bf-promotional', discount ? 'true' : 'false');
      if (imageBadge) {
        if (imageBadge.textContent !== config.badgeLabel) imageBadge.textContent = config.badgeLabel;
        imageBadge.hidden = !discount;
      }
      if (saleBadge) saleBadge.hidden = !discount;
      arrangeNativeBadges(productRoot, Boolean(discount));
    } catch (error) {
      standard.hidden = false; vip.hidden = true;
      element.setAttribute('data-bf-ready', 'standard');
      if (productRoot) productRoot.setAttribute('data-bf-promotional', 'false');
      if (imageBadge) imageBadge.hidden = true;
      if (saleBadge) saleBadge.hidden = true;
      arrangeNativeBadges(productRoot, false);
    }
  }
  function scan(root) {
    if (root.matches && root.matches('[data-bf-price]')) hydrate(root);
    root.querySelectorAll('[data-bf-price]').forEach(hydrate);
    if (root.matches && root.matches('[data-groups-pr-form]')) updateGroup(root);
    root.querySelectorAll('[data-groups-pr-form]').forEach(updateGroup);
    var access = window.EarlyBF.getState();
    root.querySelectorAll('[data-bf-storage-warning]').forEach(function (node) { node.hidden = !access.active || access.persistent !== false; });
  }
  function updateGroup(form) {
    var active = window.EarlyBF.getState().active && config.presentmentCurrency === config.currency;
    var totalBase = 0, totalReference = 0, totalFinal = 0, hasDiscount = false, validTotal = true;
    form.querySelectorAll('[data-groups-pr-item]').forEach(function (row) {
      var wrapper = row.querySelector('[data-bf-group-item]');
      if (!wrapper) return;
      var standard = wrapper.querySelector('[data-bf-group-standard]');
      var vip = wrapper.querySelector('[data-bf-group-vip]');
      var discount = null, meta, quantity = 0, base = 0;
      try {
        meta = JSON.parse(row.getAttribute('data-bf-group-meta'));
        var control = row.querySelector('[data-groups-pr-sl]');
        var option = control.tagName === 'SELECT' ? control.options[control.selectedIndex] : control;
        var checkbox = row.querySelector('[data-groups-pr-ck]');
        var selected = !checkbox || checkbox.checked;
        quantity = selected ? Number(row.querySelector('[data-groups-qty-value]').value) : 0;
        if (!Number.isSafeInteger(quantity) || quantity < 0) throw core.fault('invalid-money');
        base = Number(option.getAttribute('data-price'));
        core.money(base);
        if (active && !meta.giftCard && !meta.sellingPlan) discount = core.group(meta.tags, config);
        var lineBase = base * quantity;
        var lineReference = core.reference(base, Number(option.getAttribute('data-cpprice'))) * quantity;
        var lineFinal = discount ? core.price(base, discount.amount).final * quantity : lineBase;
        core.money(lineBase); core.money(lineFinal);
        totalBase += lineBase; totalReference += lineReference; totalFinal += lineFinal;
        if (discount && quantity) {
          var html = markup({ price: lineBase, compareAt: lineReference }, { amount: lineBase - lineFinal });
          if (vip.innerHTML !== html) vip.innerHTML = html;
          hasDiscount = true;
        }
      } catch (error) { discount = null; validTotal = false; }
      standard.hidden = Boolean(discount && quantity);
      vip.hidden = !discount || !quantity;
      wrapper.setAttribute('data-bf-ready', discount && quantity ? 'vip' : 'standard');
    });
    var total = form.querySelector('[data-bf-group-total]');
    if (total) {
      var standardTotal = total.querySelector('[data-bf-group-standard]');
      var vipTotal = total.querySelector('[data-bf-group-vip]');
      if (active && hasDiscount && validTotal) {
        var html = markup({ price: totalBase, compareAt: totalReference }, { amount: totalBase - totalFinal });
        if (vipTotal.innerHTML !== html) vipTotal.innerHTML = html;
      }
      standardTotal.hidden = active && hasDiscount && validTotal;
      vipTotal.hidden = !active || !hasDiscount || !validTotal;
      total.setAttribute('data-bf-ready', vipTotal.hidden ? 'standard' : 'vip');
    }
  }
  function updateVariant(container, variant, sticky) {
    if (!container) return;
    var nodes = Array.from(container.querySelectorAll('[data-bf-price]'));
    if (sticky) {
      var wrapper = sticky.closest('[data-bf-price]');
      if (wrapper && nodes.length) {
        var firstMeta = nodes[0].bfMeta || JSON.parse(nodes[0].getAttribute('data-bf-meta'));
        var stickyMeta = wrapper.bfMeta || JSON.parse(wrapper.getAttribute('data-bf-meta'));
        if (firstMeta.id === stickyMeta.id) nodes.push(wrapper);
      }
    }
    nodes.forEach(function (element) {
      var meta = element.bfMeta || JSON.parse(element.getAttribute('data-bf-meta'));
      if (variant && Number.isSafeInteger(variant.price)) {
        element.bfMeta = Object.assign({}, meta, { price: variant.price, variantId: variant.id,
          compareAt: variant.compare_at_price, unitPrice: variant.unit_price,
          unitMeasurement: variant.unit_price_measurement, range: false });
        delete element.dataset.bfUnavailable;
      } else {
        element.dataset.bfUnavailable = 'true';
      }
      hydrate(element);
      if (element.dataset.bfUnavailable) {
        element.querySelector('[data-bf-vip]').hidden = true;
        element.querySelector('[data-bf-standard]').hidden = false;
      }
    });
  }
  window.EarlyBFPricing = Object.freeze({ scan: scan, updateVariant: updateVariant, updateGroup: updateGroup, format: format, escape: escape });
  document.addEventListener('bf:access-changed', function () { scan(document); });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  // Observe inserted components and replacements inside known price wrappers.
  // Never rewrite arbitrary money text or the external renderer's sale value.
  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      var target = record.target && (record.target.nodeType === 3 ? record.target.parentElement : record.target);
      if (target && target.closest && !target.closest('[data-bf-vip], [data-bf-group-vip]')) {
        var affectedPrice = target.closest('[data-bf-price]');
        if (affectedPrice) hydrate(affectedPrice);
        var nativeBadges = target.closest('[data-product-badge],[data-product-single-badge]');
        var nativeOwner = nativeBadges && nativeBadges.closest(ownerSelector);
        if (nativeOwner) { var nativePrice = nativeOwner.querySelector('[data-bf-price]'); if (nativePrice) hydrate(nativePrice); }
      }
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && !node.closest('[data-bf-vip], [data-bf-group-vip]')) {
          if (node.matches && node.matches('[data-product-badge],[data-product-single-badge]')) {
            var owner = node.closest(ownerSelector), price = owner && owner.querySelector('[data-bf-price]');
            if (price) hydrate(price);
          }
          scan(node);
        }
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  scan(document);
})(window, document);